import { lsAdminPublicClient } from "../http-client";
import { PlayerAllwynDraw } from "../models/allwyn-draw-models";
import { PlayerHistory, PlayerAccountStatus } from "../models/player-api-models";

export namespace PlayerApi {
    export async function fetchPlayerSpinHistory(clientId: string): Promise<PlayerHistory[]> {
        if (!clientId) return null;

        const response = await lsAdminPublicClient.get<PlayerHistory[]>(`players/${clientId}/history`);
        return response.data;
    }

    export async function fetchPlayerAccountStatus(clientId: string): Promise<PlayerAccountStatus> {
        try {
            if (!clientId) return;

            const response = await lsAdminPublicClient.get<PlayerAccountStatus>(`/players/${clientId}/account`);
            return response.data;
        } catch (error: any) {
            return error.response;
        }
    }

    export async function fetchPlayerAllwynDraw(clientId: string): Promise<PlayerAllwynDraw> {
        try {
            if (!clientId) return;

            const response = await lsAdminPublicClient.get<PlayerAllwynDraw>(`/players/${clientId}/allwyn-draw`);
            return response.data;
        } catch (error: any) {
            return error.response;
        }
    }
}
